<template>
  <div class="online-content">
    <Card shadow>
      <Row :gutter="24">
        <Col span="5" style="display:none">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">代理组:</span>
            <Select
              v-model="table.params.platids"
              placeholder="筛选所属平台"
              multiple
              clearable
              @on-change="platChange"
            >
              <Option
                v-for="(item, index) in plat_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.app_ids"
              placeholder="筛选代理"
              multiple
              clearable
            >
              <Option
                v-for="(item, index) in app_list"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 110px">多语言分类:</span>
            <Select
                v-model="table.params.lang_type"
                filterable
                placeholder="选择多语言分类"
                clearable
            >
              <Option
                  v-for="item in globalLangList"
                  :value="item.value"
                  :label="item.name"
                  :key="item.value"
              >
                {{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 90px">货币分类:</span>
            <Select
                v-model="table.params.currency_type"
                filterable
                placeholder="选择货币分类"
                clearable
            >
              <Option
                  v-for="item in currencyList"
                  :value="item.currency"
                  :label="item.name"
                  :key="item.currency"
              >
                {{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">游戏:</span>
            <Select
              v-model="table.params.gid"
              filterable
              clearable
              :max-tag-count="3"
              placeholder="下拉筛选游戏"
            >
              <Option
                v-for="(item, index) in select.game_list"
                :value="item.game_id"
                :label="item.game_name"
                :key="index"
              >
                {{ item.game_name }}
                <!-- <span style="color:#bbb">({{item.game_id}})</span> -->
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="2" style="display: flex; justify-content: space-between">
          <Button type="primary" @click.native="searchData()" :loading="loading"
            >查询</Button
          >
        </Col>
      </Row>
    </Card>
    <Collapse v-model="pannelValue">
      <Panel name="1">
        趋势图
        <div slot="content">
          <Select
            v-model="select.chartColumnList"
            filterable
            placeholder="筛选趋势图展示数据"
            multiple
            clearable
            style="width: 350px; margin-right: 20px"
          >
            <Option
              v-for="(item, index) in select.chartShowColumn"
              :value="item.name"
              :key="index"
              >{{ item.name }}</Option
            >
          </Select>
          <Select
            v-model="currentCheck"
            filterable
            placeholder="筛选趋势图展示盘口"
            multiple
            clearable
            :max-tag-count="3"
            style="width: 380px"
          >
            <Option
              v-for="(item, index) in currentAppList"
              :value="item.appid"
              :key="index"
              >{{ item.appName }}</Option
            >
          </Select>
          <ve-line
            v-if="chartData.columns.length > 1"
            :data="chartData"
            :settings="chartSettings"
            :extend="chartExtend"
            ref="onlinePlayRef"
            style="margin-top: 12px"
          ></ve-line>
        </div>
      </Panel>
    </Collapse>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      style="margin-top: 12px"
    ></Table>
  </div>
</template>
<script>
import { GetAllGameList, TransTopReq } from '@/api/admin/risk'
import moment from 'moment'
import {mapState} from "vuex";
export default {
  name: 'HandleOnlinePlayData',
  data() {
    return {
      select: {
        game_list: [], //游戏列表
        dataTime: new Date(moment(0, 'HH').format('YYYY-MM-DD HH:mm:ss')),
        chartShowColumn: [
          { name: '在线' },
          { name: '在玩' },
          { name: '昨日在线' },
          { name: '昨日在玩' }
        ],
        chartColumnList: []
      },
      allColumns: [],
      currentAppList: [],
      currentCheck: [],
      updateTime: null,
      pannelValue: '1',
      chartData: {
        columns: ['time', ''],
        rows: []
      },
      chartSettings: {
        yAxisType: 'normal',
        scale: [true, true]
      },
      chartExtend: {
        series: { smooth: false },
        legend: { show: true },
        axisLabel: {
          formatter: function(value) {
            return ' ' + value.substring(5)
          }
        }
        //默认不显示
        // legend: {
        //     selected: {
        //         昨日在线: false,
        //         昨日在玩: false,
        //     },
        // },
      },
      loading: false,
      TransTopReqTimer: null,
      timestamp: 0,
      tableTotal: this.getTableTotal(),
      table: {
        params: {
          platid: 0,
          platids: [],
          gid: 0, //所选择得游戏
          app_id: 0, //所选择分组
          app_ids: [],
          stime: 0,
          etime: 0,
          page: 1,
          currency_type: '',
          lang_type: ''
        },
        total: 0,
        page: 1,
        data: [],
        columns: [
          { type: 'index', title: '序号', width: 50, align: 'center' },
          {
            key: 'app_name',
            align: 'center',
            width: 153,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '盘口',
                '显示该玩家所属盘口；显示盘口APP名称'
              )
          },
          {
            key: 'lang_type',
            align: 'center',
            width: 153,
            resizable: true,
            renderHeader: (h, params) =>
                this.renderHeader(
                    h,
                    '多语言分类',
                    '显示该玩家所属盘口；显示盘口使用的语言'
                ),
            render: (h, params) => {
              return h("span", this.langFilter(params.row.lang_type));
            }
          },
          {
            key: 'currency_type',
            align: 'center',
            width: 153,
            resizable: true,
            renderHeader: (h, params) =>
                this.renderHeader(
                    h,
                    '货币分类',
                    '显示该玩家所属盘口；显示盘口使用的货币'
                )
          },
          {
            key: 't_game',
            align: 'center',
            width: 276,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '当前在线值/当前在玩值',
                '当前在线值/当前在玩值'
              ),
            render: (h, params) =>
              this.rColItem(
                h,
                params.row.now_data.now_online,
                params.row.now_data.now_game
              )
          },
          {
            key: 'max_online',
            align: 'center',
            width: 276,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '当日在线峰值/昨日在线峰值',
                '当日在线峰值/昨日在线峰值'
              ),
            render: (h, params) =>
              this.rColItem(
                h,
                params.row.day_data.max_online,
                params.row.yesterday_data.max_online
              )
          },
          {
            key: 'nick_name',
            align: 'center',
            width: 276,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '当日在玩峰值/昨日在玩峰值',
                '当日在玩峰值/昨日在玩峰值'
              ),
            render: (h, params) =>
              this.rColItem(
                h,
                params.row.day_data.t_max_game.max_game,
                params.row.yesterday_data.t_max_game.max_game
              )
          },
          {
            key: 'online_ave',
            align: 'center',
            width: 276,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '当日在线平均值/昨日在线平均值',
                '当日在线平均值/昨日在线平均值'
              ),
            render: (h, params) =>
              this.rColItem(
                h,
                params.row.day_ave.online_ave,
                params.row.yesterday_ave.online_ave
              )
          },
          {
            key: 't_game_ave',
            align: 'center',
            width: 276,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '当日在玩平均值/昨日在玩平均值',
                '当日在玩平均值/昨日在玩平均值'
              ),
            render: (h, params) =>
              this.rColItem(
                h,
                params.row.day_ave.t_game_ave,
                params.row.yesterday_ave.t_game_ave
              )
          },
          {
            key: 'bet',
            align: 'center',
            width: 276,
            resizable: true,
            render: (h, params) =>
              h(
                'span',
                params.row.app_id == -10
                  ? '-'
                  : (params.row.history_data.max_online || '') +
                      (params.row.history_data.max_online_time
                        ? `(${params.row.history_data.max_online_time})`
                        : '')
              ),
            renderHeader: (h, params) =>
              this.renderHeader(h, '历史在线峰值', '历史在线峰值')
          },
          {
            key: 'hit',
            align: 'center',
            width: 276,
            resizable: true,
            render: (h, params) =>
              h(
                'span',
                params.row.app_id == -10
                  ? '-'
                  : (params.row.history_data.t_max_game.max_game || 0) +
                      (params.row.history_data.t_max_game.max_time
                        ? `(${params.row.history_data.t_max_game.max_time})`
                        : '')
              ),
            renderHeader: (h, params) =>
              this.renderHeader(h, '历史在玩峰值', '历史在玩峰值')
          }
        ]
      },
      ChannelMoney_Modal: { show: false, data: {}, type: 0 }
    }
  },
  computed: {
    ...mapState({
      currencyList: state => state.app.globalCurrencyList
    }),
  },
  watch: {
    allColumns() {
      this.updateColumn()
    },
    currentCheck() {
      this.updateColumn()
    },
    'select.chartColumnList': function() {
      console.log('updateToJs ')
      this.updateColumn()
    }
  },
  methods: {
    updateColumn() {
      if (this.updateTime) {
        clearTimeout(this.updateTime)
      }
      this.updateTime = setTimeout(() => {
        let arr = ['time']
        let from1 =
          this.select.chartColumnList.length > 0
            ? this.select.chartColumnList
            : ['在线', '在玩', '昨日在线', '昨日在玩']
        let from2 = []
        if (this.currentCheck.length > 0) {
          this.currentCheck.forEach(item => {
            let find2 = this.currentAppList.find(el => el.appid == item)
            if (find2) from2.push(find2.appName)
          })
        } else {
          from2 = this.currentAppList.map(el => el.appName)
        }
        this.chartExtend.legend.show = from1.length * from2.length <= 20
        from1.forEach(v1 => {
          from2.forEach(v2 => {
            arr.push(v2 + v1)
          })
        })
        this.chartData.columns = arr
      }, 200)
    },
    getPlatId(appid) {
      let item = this.app_list.find(el => el.appid == appid)
      return item ? item.platform : 0
    },
    platChange(item) {
      this.table.params.app_ids = []
    },
    getAppList() {
      return this.app_list.filter(el =>
        this.table.params.platids.includes(el.platform)
      )
    },
    rColItem(h, val1, val2) {
      let color = val1 > val2 ? 'red' : val1 < val2 ? '#32CD32' : 'black'
      return h('span', [
        h('span', { style: { color } }, val1 || 0),
        h('span', ` / ${val2 || 0}`)
      ])
    },
    searchData() {
      if (this.loading) return
      let allList = this.getAllHttpAppid(this.table.params)
      let httpList = []
      let loadingArr = [...allList]
      this.timestamp = new Date().getTime() //设置请求时间
      this.table.data = []
      this.chartData.rows = []
      this.allColumns = []
      this.currentAppList = []
      this.currentCheck = []
      for (let i = 0, len = allList.length; i < len; i++) {
        let app_id = allList[i]
        let app_name = ''
        let platform = ''
        let platid = 0
        let item = this.app_list.find(el => el.appid == app_id)
        if (item) {
          app_name = item.appName
          platid = item.platform
          let platitem = this.plat_list.find(el => el.id == platid)
          if (platitem) {
            platform = platitem.name
          }
        }
        let el = { platid, app_id, app_name }
        let param = this.getTransTopParams('GetOnlineGame', {
          platform,
          platid,
          app_id,
          app_name,
          game_id: this.table.params.gid || 0,
          general: -1,
          pack_no: -1,
          timestamp: this.timestamp,
          currency_type: this.table.params.currency_type,
          lang_type: this.table.params.lang_type
        })
        httpList.push(param)
      }
      this.tableTotal = this.getTableTotal()
      let max = Math.min(5, httpList.length)
      let result = []
      for (let i = 0; i < max; i++) {
        this.toHttp(httpList, loadingArr, result)
      }
    },
    async toHttp(httpList, loadingArr, resultArray) {
      if (httpList.length > 0) {
        let param = httpList.shift()
        if (this.isCurrentHttp(param.timestamp)) {
          this.openTimer()
          let canNext = true
          let res = await TransTopReq(param)
          canNext = this.isCurrentHttp(param.timestamp) && !!res._param
          if (canNext) {
            let data = res._param
            data.app_name = param.app_name
            data.app_id = param.app_id
            loadingArr.shift()
            data.now_data = {
              now_online: data.list[data.list.length - 1].online,
              now_game: data.list[data.list.length - 1].t_game
            }
            resultArray.push(data)
            if (httpList.length > 0) {
              this.toHttp(httpList, loadingArr, resultArray)
            }
            if (loadingArr.length == 0) {
              this.closeTimer()
              let result = []
              let columns = []
              let rowList = []
              this.currentAppList = [{ appid: -10, appName: '合计' }]
              for (let i = 0; i < resultArray.length; i++) {
                let items = resultArray[i]
                let appname = items.app_name
                this.currentAppList.push({
                  appid: items.app_id,
                  appName: appname
                })
                let tPlay = `${appname}在玩`
                let tOnline = `${appname}在线`
                let yPlay = `${appname}昨日在玩`
                let yOnline = `${appname}昨日在线`
                let list = items.list
                columns.push(...[tPlay, tOnline, yPlay, yOnline])
                this.tableTotal.day_data.max_online +=
                  items.day_data.max_online || 0
                this.tableTotal.yesterday_data.max_online +=
                  items.yesterday_data.max_online || 0
                this.tableTotal.day_data.t_max_game.max_game +=
                  items.day_data.t_max_game.max_game || 0
                this.tableTotal.yesterday_data.t_max_game.max_game +=
                  items.yesterday_data.t_max_game.max_game || 0
                this.tableTotal.day_ave.online_ave +=
                  items.day_ave.online_ave || 0
                this.tableTotal.day_ave.t_game_ave +=
                  items.day_ave.t_game_ave || 0
                this.tableTotal.yesterday_ave.online_ave +=
                  items.yesterday_ave.online_ave || 0
                this.tableTotal.yesterday_ave.t_game_ave +=
                  items.yesterday_ave.t_game_ave || 0
                this.tableTotal.now_data.now_online +=
                  list[list.length - 1].online || 0
                this.tableTotal.now_data.now_game +=
                  list[list.length - 1].t_game || 0
                for (let k = 0; k < list.length; k++) {
                  let time = list[k].time
                  let row1 = rowList.find(item => item.time == time)
                  let isPush = !!row1
                  if (!isPush)
                    row1 = {
                      time,
                      合计在线: 0,
                      合计在玩: 0,
                      合计昨日在线: 0,
                      合计昨日在玩: 0
                    }
                  row1[tOnline] = list[k].online
                  row1[tPlay] = list[k].t_game
                  row1[yOnline] = list[k].y_online
                  row1[yPlay] = list[k].y_t_game
                  row1['合计在线'] += list[k].online
                  row1['合计在玩'] += list[k].t_game
                  row1['合计昨日在线'] += list[k].y_online
                  row1['合计昨日在玩'] += list[k].y_t_game
                  if (!isPush) {
                    rowList.push(row1)
                  }
                }
                delete items.list
                result.push(items)
              }
              this.chartData.rows = rowList
              this.allColumns = [
                ...columns,
                '合计在线',
                '合计在玩',
                '合计昨日在线',
                '合计昨日在玩'
              ]
              this.currentCheck = [-10]
              let tableData = [...result, this.tableTotal]
              this.table.data = tableData
              if (this.$refs.onlinePayRef) {
                this.$refs.onlinePayRef.echarts.resize()
              }
            }
          }
        }
      }
    },
    //关闭定时器
    closeTimer() {
      this.loading = false
      clearTimeout(this.TransTopReqTimer)
      this.TransTopReqTimer = null
    },
    //批量请求开启定时器8秒超时
    openTimer() {
      this.closeTimer()
      this.loading = true
      this.TransTopReqTimer = setTimeout(() => {
        this.loading = false
      }, 6000)
    },
    //透传接口请求参数 请求方法 请求参数
    getTransTopParams(func, param) {
      return {
        mod: 'root',
        platid: param.platid,
        app_id: param.app_id,
        app_name: param.app_name,
        platform: param.platform,
        timestamp: param.timestamp,
        param: {
          _mod: 'manager',
          _func: func,
          _param: { ...param }
        }
      }
    },
    getTableTotal() {
      return {
        app_id: -10,
        app_name: '合计',
        now_data: {
          now_online: 0,
          now_game: 0
        },
        day_data: {
          max_online: 0,
          t_max_game: {
            max_game: 0
          }
        },
        yesterday_data: {
          t_max_game: {
            max_game: 0
          },
          max_online: 0
        },
        day_ave: {
          online_ave: 0,
          t_game_ave: 0
        },
        yesterday_ave: {
          online_ave: 0,
          t_game_ave: 0
        }
      }
    },
    isCurrentHttp(timestamp) {
      return timestamp == this.timestamp
    },
    async initFunc() {
      let item = this.app_list[0]
      this.table.params.app_id = item.appid
      this.searchData()
    },
    GetAllGameList() {
      GetAllGameList({ gtype: 0, page: 1, page_size: 10000 }).then(res => {
        this.select.game_list = res._param.data || []
      })
    }
  },
  created() {
    this.initFunc()
    this.GetAllGameList()
  }
}
</script>
<style lang="less" scoped>
.online-content {
  height: 100%;
  overflow: auto;
}
.btn_batch {
  margin-right: 12px;
}
</style>
